import {saveAs} from 'file-saver';

export const FILE_TYPES_MIME_MAP = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
} as const;

type FileType = keyof typeof FILE_TYPES_MIME_MAP;

export const resToFileDownload = (res: any, fileName: string, fileType: FileType) => {
  const blob = new Blob([res.body], {type: fileType});
  const file = new File([blob], fileName, {type: fileType});
  saveAs(file);
};
